/**
 * TicketSalesCampaignCreatePage — `NEW_CAMPAIGN_PATH`. A blank campaign
 * that, once created, opens on its own edit page.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { JustCreatedState } from '../shared/editor-page/use-just-created';

import { blankCampaignForm, toCreateRequest } from './components/campaign-form';
import { TicketSalesCampaignEditor } from './components/TicketSalesCampaignEditor';
import { campaignEditPath } from './ticket-sales-campaigns-paths';
import { useCreateTicketSalesCampaign } from './use-ticket-sales-campaigns';

export default function TicketSalesCampaignCreatePage() {
  const create = useCreateTicketSalesCampaign();
  const navigate = useNavigate();
  const [initial] = useState(() => blankCampaignForm(new Date()));
  return (
    <TicketSalesCampaignEditor
      initial={initial}
      persist={(values) => create.mutateAsync(toCreateRequest(values))}
      onSaved={(campaign) => {
        const state: JustCreatedState = { created: true };
        navigate(campaignEditPath(campaign.id), { replace: true, state });
      }}
    />
  );
}
